'use strict';

import 'components/page';